import {registerLicense} from "@syncfusion/ej2-base";

export function initSyncfusion(): void {
  registerLicense("Ngo9BigBOggjHTQxAR8/V1NHaF1cWWhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEZiWH1fcHZRRGFbWEZxXQ==");
}
